// extracted by mini-css-extract-plugin
export default {"mainContainer":"sidelinksbar_mainContainer__Di9wN","linkBox":"sidelinksbar_linkBox__0n8XC","iconBox":"sidelinksbar_iconBox__Yc109"};